var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgYellowLineOne = function SvgYellowLineOne(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 9,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.098 5.048c16.525-.79 62.133-2.161 126.851-2.204 52.134-.034 116.668.794 188.389 3.484",
    stroke: "#FFD43E",
    strokeWidth: 3.733,
    strokeLinecap: "round"
  })));
};
export default SvgYellowLineOne;